import { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import PasswordInput from '../components/inputs/PasswordInput'
import RoundedButton from '../components/buttons/RoundedButton'
import LoadingModal from '../components/modals/LoadingModal'
import { ToastContainer, toast } from 'react-toastify'
import login from '../assets/login.png'
import arrow from '../assets/arrow.png'
import strings from '../res/strings'
import 'react-toastify/dist/ReactToastify.css'

const RecoverPasswordNew = () => {
    const { state } = useLocation()
    let email = null
    let recoverCode = null

    if (state) {
        ( { email, recoverCode } = state)
    }

    const [newPassword, setNewPassword] = useState('')
    const [newPasswordError, setNewPasswordError] = useState(null)

    const [isLoading, setIsLoading] = useState(false)

    const navigate = useNavigate()

    // Handle changes in recover code input text
    const onChangeNewPassword = (newPasswordText) => {
        setNewPasswordError(null)
        setNewPassword(newPasswordText.target.value)
    }

    // Check if password is valid (Minimum 8 characters, at least 1 upper case and 1 number)
    const isValidPassword = (password) => {
        const regex = /^(?=.*[A-Z])(?=.*\d).{8,}$/
        return regex.test(password)
    }

    // Update password in database
    const saveNewPassword = () => {
        let hasErrors = false

        if (newPassword.trim().length === 0) {
            setNewPasswordError(strings.insertPasswordError)
            hasErrors = true
        } else if(!isValidPassword(newPassword)) {
            hasErrors = true
            setNewPasswordError(strings.invalidPassword)
        }

        if (!hasErrors) {
            setIsLoading(true)
            
            const data = { 
                Email: email ? email.toLowerCase() : null,
                RecoveryCode: recoverCode ? recoverCode : null,
                NewPassword: newPassword
            }

            // Update password
            fetch('/api/User/ResetPassword', {
                method:'PUT',
                headers: { 
                  'Accept': 'application/json',
                  'Content-Type': 'application/json; charset=UTF-8'
                }, 
                mode: 'cors',
                body: JSON.stringify(data)
            }).then(async response => {
                setTimeout(async () => {
                    setIsLoading(false)
          
                    if (response.status === 200) {
                        navigate('/recover-password-success')
                    } else if (response.status === 400) {
                        const errorMessage = await response.text()
    
                        if(errorMessage === '"New password cannot be the same as the old password."') {
                            showErrorToast(strings.invalidNewPassword)
                        } else if (errorMessage === '"Invalid recovery code."'){
                            showErrorToast(strings.invalidRecoverCode)
                        } else {
                            showErrorToast(strings.resetPasswordError)
                        }
    
                    } else {
                        showErrorToast(strings.resetPasswordError)
                    }
                }, 1000)
            
            }).catch((error) => {
                setTimeout(() => {
                    setIsLoading(false)
                showErrorToast(error)
                }, 1000) 
            })
        }
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <div className='flex flex-row h-full'>
            <div className='flex-1'>
                <img className='min-h-screen object-cover' src={login} alt='Login Alagem Digital'/>
            </div>

            <div className='flex flex-col flex-1 mb-6'>

                <div className='flex flex-row items-center mt-16 px-[7.5rem] space-x-2'>
                    <Link to='/'>
                        <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                    </Link>
                    <p className='font-montserrat font-semibold text-accent'>{strings.recoverPassword}</p>
                </div>
                    
                <div className='flex flex-1 flex-col px-[7.5rem] justify-center'>

                    <p className='font-montserrat text-center text-xl font-bold mt-11'>{strings.newPassword}</p>
                    <p className='font-montserrat text-center mt-1'>{strings.newPasswordMessage}</p>

                    <div className='flex flex-col mt-11'>
                        <PasswordInput
                            value={newPassword}
                            placeholder={strings.insertNewPassword}
                            onChange={onChangeNewPassword}
                            error={newPasswordError}
                        />
                        <p className='font-montserrat text-sm font-medium text-black-transparent mt-4'>{strings.passwordMessage}</p>
                        <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{newPasswordError ? newPasswordError : ''}</p>
                    </div>

                    <div className='flex self-center mt-11 w-60'>
                        <RoundedButton 
                            onClick={saveNewPassword}
                            text={strings.setNewPassword}
                            height={48}
                            bgColor='#007EB4'
                        />
                    </div>
                    
                </div>
            </div>

            <ToastContainer />

            { isLoading ?
                <LoadingModal />
            : null
            }


        </div>
  )
}

export default RecoverPasswordNew